import { useContext, useEffect } from 'react';

import MetricCacheContext from 'contexts/MetricCacheContext';

const useRequestMetrics = ({ metricIds }: { metricIds: string[] }) => {
  const { requestMetricsByIds } = useContext(MetricCacheContext);

  useEffect(() => {
    if (metricIds.length > 0) {
      requestMetricsByIds(metricIds);
    }
  }, [metricIds, requestMetricsByIds]);
};

export default useRequestMetrics;
